import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const networkRoles = ["PLAYER", "COACH", "SCOUT", "AGENT", "OTHER"];

const NetworkPersonas = ({ isDataLoading }: { isDataLoading: boolean }) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "network",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentRole = searchParams.get("role")?.toUpperCase() ?? "PLAYER";

  const handleOnChangeType = (role: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("role", role);
    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto", whiteSpace: "nowrap", padding: "0 8px 8px" }}>
      <Box
        sx={{
          display: "flex",
          gap: "8px",
          width: "fit-content",
        }}
      >
        {networkRoles.map((role) => (
          <Chip
            key={role}
            label={t(role.toLowerCase())}
            component="button"
            variant="outlined"
            clickable
            onClick={() => handleOnChangeType(role)}
            disabled={isDataLoading}
            sx={{
              padding: "1px 4px",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              color: currentRole === role ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
              border: currentRole === role ? "1px solid var(--Brand-600, #008B07)" : "none",
              background: currentRole === role ? "var(--Brand-25, #F6FFF5)" : "transparent",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default NetworkPersonas;
